import { useTranslation } from 'react-i18next'
import React from 'react'

import Center from './Center'
import IconBlock from '../presentation/IconBlock'
import StatePresenter, {
  RefetchingIndicator as _RefetchingIndicator
} from '../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext({})
const { Provider } = Context
export const useStatePresenter = () => React.useContext(Context) || {}
export const useIsRefetching = () => useStatePresenter().isRefetching

const EmptyMessage = () => {
  const { t } = useTranslation('common')

  return (
    <Center>
      <IconBlock icon="BsInbox" title={t('emptyMessage')} />
    </Center>
  )
}

const ErrorMessage = ({ error }) => {
  const { t } = useTranslation('common')

  return (
    <Center>
      <IconBlock icon="BsExclamationTriangle" title={t('errorMessage')} subtitle={JSON.stringify(error)} />
    </Center>
  )
}

export const RefetchingIndicator = _RefetchingIndicator

const _StatePresenter = StatePresenter

export default _StatePresenter
